export default __webpack_public_path__ + "static/media/typecrane_bcp.84bbb2c5.svg";